import React, { FC } from 'react';

import { TEXTS } from 'application/pages/BillingPage/renderer/texts';
import { ModalProps, ModalTypes } from 'application/providers/ModalProvider';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';

import useExtendSubscriptionModal from '../../model/useExtendSubscriptionModal';

import styles from './ExtendSubscriptionModal.module.scss';

const ExtendSubscriptionModal: FC<ModalProps[ModalTypes.BILLING_EXTEND_SUBSCRIPTION]> = ({
  close,
  licenses,
  submitCallback,
}) => {
  const { subscriptionCost, licenseSubscriptionLoading, isSbbolPayment, onExtendSubscriptionConfirm } =
    useExtendSubscriptionModal({
      licenses,
      close,
      submitCallback,
    });

  return (
    <ModalScreen
      title={TEXTS.BILLING_EXTEND_SUBSCRIPTION_MODAL_TITLE}
      hideCloseButton
      actionButtons={[
        <Button
          key="button_confirm_extend_subscription_modal"
          elementId="button_confirm_extend_subscription_modal"
          isLoading={licenseSubscriptionLoading || !subscriptionCost}
          type={ButtonType.PRIMARY}
          onClick={onExtendSubscriptionConfirm}>
          {TEXTS.BILLING_LICENSES_AMOUNT_BUTTON_TITLE(subscriptionCost)}
        </Button>,
        <Button
          key="button_cancel_extend_subscription_modal"
          elementId="button_cancel_extend_subscription_modal"
          type={ButtonType.SECONDARY}
          onClick={() => close()}>
          {TEXTS.BILLING_EXTEND_SUBSCRIPTION_MODAL_CANCEL}
        </Button>,
      ]}>
      <div className={styles.ExtendSubscriptionModalDesc}>
        {isSbbolPayment
          ? TEXTS.BILLING_EXTEND_SUBSCRIPTION_MODAL_DESC_SBBOL
          : TEXTS.BILLING_EXTEND_SUBSCRIPTION_MODAL_DESC}
      </div>
    </ModalScreen>
  );
};

export default ExtendSubscriptionModal;
